import * as THREE from "three";

/**
 * Функция для создания объекта THREE.Color из строки цвета.
 * @param {string} color - Цвет в формате CSS (например, "#ff0000", "rgb(255, 0, 0)", "red").
 * @returns {THREE.Color} - Объект THREE.Color.
 */
export function returnThreeColor(color) {
    return new THREE.Color(color);
}
